import { makeStyles } from '@mui/styles';
import React from 'react';

import EditorTabSet from './ssEditorTabSet';
import RuntimeTabSet from './ssRuntimeTabSet';
import { FCM_BORDER_STYLES } from '../../constants/runtime.constants';

const useStyles = makeStyles({
  changesModeWrapper: {
    margin: '8px 0',
    padding: '0 8px 8px 8px',
    border: FCM_BORDER_STYLES.GREEN,
  },
});

const SSTabSet = ({ isEditor, isControlAddedFCM, ...props }) => {
  const classes = useStyles();

  if (isEditor) {
    return <EditorTabSet {...props} />;
  }

  if (isControlAddedFCM) {
    return (
      <div className={classes.changesModeWrapper} data-ss-id={props.id}>
        <RuntimeTabSet {...props} />
      </div>
    );
  }

  return <RuntimeTabSet {...props} />;
};

export default SSTabSet;
